// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__DFtYc","disabled":"style_disabled__Sdt1y","active":"style_active__R2hUP"};